export default ({ request }) => ({
  businessCardUrlApi(data = {}) {
    return request({
      baseURL: '/api',
      url: "/oss/businessCardUrl",
      method: "post",
      data,
    });
  },
});
